import React from "react";
import { useApp } from "../../context/AppContext";
import { FONT_FAMILY, FONT_SIZES } from "../../constants/appConfig";

// ═══════════════════════════════════════════════════════════════
// Global Loading Overlay — triggered via showLoading / hideLoading
// from AppContext. Renders a centered spinner + message phrase
// over a semi-transparent backdrop.
// ═══════════════════════════════════════════════════════════════

export const LoadingOverlay = () => {
  const { loadingMessage, palette } = useApp();

  if (!loadingMessage) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.45)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
        fontFamily: FONT_FAMILY,
      }}
    >
      <div
        style={{
          background: palette.cardBg,
          borderRadius: 16,
          padding: "32px 48px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16,
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          border: `1px solid ${palette.cardBorder}`,
        }}
      >
        <div
          style={{
            width: 40,
            height: 40,
            border: `3px solid ${palette.inputBorder}`,
            borderTopColor: palette.accent1,
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <p
          style={{
            margin: 0,
            color: palette.text1,
            fontSize: FONT_SIZES.sm,
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          {loadingMessage}
        </p>
      </div>
    </div>
  );
};
